import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import LoadingSpinner from "../../../../../components/loading-spinner";
import { Button, Connected } from "./AvailableIntegrationCardAddButton.style";

type AvailableIntegrationCardAddButtonProps = {
  onConnect: () => void;
  loading: boolean;
  isConnected: boolean;
};

export const AvailableIntegrationCardAddButton = (
  props: AvailableIntegrationCardAddButtonProps
) => {
  const { onConnect, loading, isConnected } = props;

  const handleClick = useCallback(() => {
    if (isConnected) {
      return;
    }
    onConnect();
  }, [isConnected, onConnect]);

  return (
    <Button onClick={handleClick} disabled={loading || isConnected} isConnected={isConnected}>
      {loading && !isConnected && <LoadingSpinner size="14px" />}
      {isConnected && (
        <Connected>
          <FontAwesomeIcon icon={faCheckCircle} />
          <FormattedMessage
            id="containers.Integrations.AddNewIntegration.ToolIntegrated"
            defaultMessage="Tool integrated"
          />
        </Connected>
      )}
      {!loading && !isConnected && (
        <FormattedMessage
          id="containers.Integrations.AddNewIntegration.AddTool"
          defaultMessage="Add tool"
        />
      )}
    </Button>
  );
};
